import React, { FC, lazy, Suspense } from 'react';

import useLocalFeatureFlag from '@/shared/hooks/useLocalFeatureFlag';
import { Features } from '@/shared/configs/features';

type WagmiProviderComponentProps = {
    children: React.ReactNode;
};

// Lazy load the WagmiProviderComponent
const LazyWagmiProviderComponent = lazy(() =>
    import('./WagmiProvider').then((module) => ({
        default: module.WagmiProviderComponent,
    })),
);

export const WagmiProviderWrapper: FC<WagmiProviderComponentProps> = ({ children }) => {
    const isNewWalletConnect = useLocalFeatureFlag(Features.NewWalletConnect, true);

    if (!isNewWalletConnect) {
        return <>{children}</>;
    }

    return (
        <Suspense fallback={null}>
            <LazyWagmiProviderComponent>{children}</LazyWagmiProviderComponent>
        </Suspense>
    );
};
